module.exports = __webpack_public_path__ + "static/media/producer-up-icon.2cf7cf2a.svg";